import firebase from '@/store/modules/analytics/firebase';
import facebookPixel from '@/store/modules/analytics/facebook-pixel';

export default {
  namespaced: true,
  modules: {
    firebase,
    facebookPixel,
  },
};
